import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { stepDescription } from 'modules/processes/components/ProcessSettings/Steps/StepDescription'

export const useStepActionDescription = () => {
  const { currentStep } = useFormProvider()

  const description = stepDescription({
    step: currentStep,
    stepProgressionCondition: currentStep.progressionCondition || '',
    stepProgressionConditionResourceKey: currentStep.progressionConditionResourceKey || '',
  })

  return description
}
